export const ITEM_TYPE = theme => {
  return {
    Performance: {
      label: 'Performance',
      color: theme.palette.tertiary.main
    },
    Characteristic: {
      label: 'Characteristic',
      color: theme.palette.secondary.main
    }
  }
}